var jade = require("/app/app/assets/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div class=\"route-login\"><section class=\"extra-padding\"><container><div class=\"prose text-center\"><h1>Welcome back</h1></div><od-signin></od-signin></container></section></div>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./javascripts/market/routes/humans/login.jade
 ** module id = 3560
 ** module chunks = 3
 **/